import { useNavigate } from "react-router-dom";
import { PRESENTATIONS } from "../../../components/presentations/presentationsCatalog";
import MobileList from "../../ui/MobileList";
import MobileListItem from "../../ui/MobileListItem";
import MobileEmpty from "../../ui/MobileEmpty";

export default function MobilePresentations() {
  const navigate = useNavigate();

  if (PRESENTATIONS.length === 0) {
    return (
      <div className="p-4">
        <h1 className="text-xl text-[#d59106] mb-3">Apresentações</h1>
        <MobileEmpty message="Nenhuma apresentação cadastrada." />
      </div>
    );
  }

  return (
    <div className="p-4 pb-8">
      <h1 className="text-xl text-[#d59106] mb-1">Apresentações</h1>
      <p className="text-orange-100/60 text-xs mb-4">Acesso master · materiais para sócios</p>
      <MobileList>
        {PRESENTATIONS.map((item) => (
          <MobileListItem
            key={item.id}
            title={item.title}
            subtitle={`${item.date} · ${item.description}`}
            onClick={() => navigate(`/manafix/presentations/${item.id}`)}
          />
        ))}
      </MobileList>
    </div>
  );
}
